import { Language } from '../store/slices/languageSlice';

type TranslationKey = 
  | 'settings'
  | 'theme'
  | 'language'
  | 'logout'
  | 'logoutDevice'
  | 'light'
  | 'dark'
  | 'blue'
  | 'autoDetect'
  | 'english'
  | 'arabic'
  | 'send'
  | 'chatPlaceholder'
  | 'newChat'
  | 'disclaimer'
  | 'supportedFiles'
  | 'none'
  | 'customised'
  | 'default'
  | 'background'
  | 'more';

type Translations = {
  [key in Language]: {
    [key in TranslationKey]: string;
  };
};

// We only need English and Arabic as per requirements
export const translations: Omit<Translations, 'auto-detect'> = {
  english: {
    settings: 'Settings',
    theme: 'Theme',
    language: 'Language',
    background: 'Background',
    none: 'None',
    customised: 'Customised',
    default: 'Default',
    logout: 'Log out',
    logoutDevice: 'Log out on this device',
    light: 'Light',
    dark: 'Dark',
    blue: 'Blue',
    autoDetect: 'Auto-detect',
    english: 'English',
    arabic: 'Arabic',
    send: 'Send',
    chatPlaceholder: 'Ask RegenAI anything...',
    newChat: 'New Chat',
    disclaimer: 'RegenAI can make mistakes. Please check the usage policy.',
    supportedFiles: 'Supported: PDF, TXT, DOCX, CSV files or URLs',
    more: 'More'
  },
  arabic: {
    settings: 'الإعدادات',
    theme: 'السمة',
    language: 'اللغة',
    background: 'خلفية',
    none: 'لا أحد',
    customised: 'حسب الطلب',
    default: 'تقصير',
    logout: 'تسجيل الخروج',
    logoutDevice: 'تسجيل الخروج من هذا الجهاز',
    light: 'فاتح',
    dark: 'داكن',
    blue: 'أزرق',
    autoDetect: 'الكشف التلقائي',
    english: 'الإنجليزية',
    arabic: 'العربية',
    send: 'إرسال',
    chatPlaceholder: 'اسأل RegenAI عن أي شيء',
    newChat: 'محادثة جديدة',
    disclaimer: 'يمكن أن يرتكب ريجين اي أخطاء. يرجى مراجعة سياسة الاستخدام.',
    supportedFiles: 'الملفات المدعومة: PDF، TXT، DOCX، CSV أو روابط URL',
    more: 'المزيد'
  }
};

// Helper function to get translations based on current language
export const getTranslation = (
  language: Language, 
  key: TranslationKey
): string => {
  if (language === 'auto-detect') {
    // Default to English for auto-detect
    return translations.english[key];
  }
  return translations[language][key];
};